import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "page-dall"
};
const _hoisted_2 = {
  class: "inner custom-scroll"
};
const _hoisted_3 = {
  class: "sd-box"
};
const _hoisted_4 = {
  class: "sd-params"
};
const _hoisted_5 = {
  class: "param-line pt-1"
};
const _hoisted_6 = {
  class: "form-item-inner"
};
const _hoisted_7 = {
  class: "param-line"
};
const _hoisted_8 = {
  class: "form-item-inner"
};
const _hoisted_9 = {
  class: "param-line"
};
const _hoisted_10 = {
  class: "form-item-inner"
};
const _hoisted_11 = {
  class: "param-line"
};
const _hoisted_12 = {
  class: "form-item-inner"
};
const _hoisted_13 = {
  class: "param-line"
};
const _hoisted_14 = {
  class: "text-info"
};
const _hoisted_15 = {
  class: "submit-btn"
};
const _hoisted_16 = {
  class: "task-list-box pl-6 pr-6 pb-4 pt-4 h-dvh"
};
const _hoisted_17 = {
  class: "job-list-box"
};
const _hoisted_18 = {
  class: "finish-job-list"
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  class: "job-item"
};
const _hoisted_21 = {
  class: "image-slot"
};
const _hoisted_22 = {
  class: "image-slot"
};
const _hoisted_23 = {
  class: "err-msg-container"
};
const _hoisted_24 = {
  class: "opt"
};
const _hoisted_25 = {
  class: "remove"
};
import nodata from "@/assets/img/no-data.png";
import { nextTick, onMounted, onUnmounted, ref } from "vue";
import { Delete, InfoFilled, Picture } from "@element-plus/icons-vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage, ElMessageBox } from "element-plus";
import Clipboard from "clipboard";
import { checkSession, getClientId, getSystemInfo } from "@/store/cache";
import { useSharedStore } from "@/store/sharedata";
import TaskList from "@/components/TaskList.vue";
import BackTop from "@/components/BackTop.vue";
import { showMessageError, showMessageOK } from "@/utils/dialog";
export default {
  __name: 'Dalle',
  setup(__props) {
    const listBoxHeight = ref(0);
    // const paramBoxHeight = ref(0)
    const isLogin = ref(false);
    const loading = ref(true);
    const colWidth = ref(220);
    const isOver = ref(false);
    const previewURL = ref("");
    const store = useSharedStore();
    const models = ref([]);
    const resizeElement = function () {
      listBoxHeight.value = window.innerHeight - 58;
      // paramBoxHeight.value = window.innerHeight - 110
    };
    resizeElement();
    window.onresize = () => {
      resizeElement();
    };
    const qualities = [{
      name: "标准",
      value: "standard"
    }, {
      name: "高清",
      value: "hd"
    }];
    const dalleSizes = ["1024x1024", "1792x1024", "1024x1792"];
    const fluxSizes = ["1024x1024", "1024x768", "768x1024", "1280x960", "960x1280", "1366x768", "768x1366"];
    const sizes = ref(dalleSizes);
    const styles = [{
      name: "生动",
      value: "vivid"
    }, {
      name: "自然",
      value: "natural"
    }];
    const params = ref({
      client_id: getClientId(),
      quality: "standard",
      size: "1024x1024",
      style: "vivid",
      prompt: ""
    });
    const finishedJobs = ref([]);
    const runningJobs = ref([]);
    const power = ref(0);
    const dallPower = ref(0); // 画一张 SD 图片消耗算力
    const clipboard = ref(null);
    const userId = ref(0);
    const selectedModel = ref(null);
    onMounted(() => {
      initData();
      clipboard.value = new Clipboard(".copy-prompt");
      clipboard.value.on("success", () => {
        showMessageOK("复制成功！");
      });
      clipboard.value.on("error", () => {
        showMessageError("复制失败！");
      });
      getSystemInfo().then(res => {
        dallPower.value = res.data["dall_power"];
      }).catch(e => {
        showMessageError("获取系统配置失败：" + e.message);
      });
      store.addMessageHandler("dall", data => {
        // 丢弃无关消息
        if (data.channel !== "dall" || data.clientId !== getClientId()) {
          return;
        }
        if (data.body === "FINISH" || data.body === "FAIL") {
          page.value = 0;
          isOver.value = false;
          fetchFinishJobs();
        }
        nextTick(() => fetchRunningJobs());
      });

      // 获取模型列表
      httpGet("/dall/models").then(res => {
        models.value = res.data;
        selectedModel.value = models.value[0];
        params.value.model_id = selectedModel.value.id;
      }).catch(e => {
        showMessageError("获取模型列表失败：" + e.message);
      });
    });
    onUnmounted(() => {
      clipboard.value.destroy();
      store.removeMessageHandler("dall");
    });
    const initData = () => {
      checkSession().then(user => {
        power.value = user["power"];
        userId.value = user.id;
        isLogin.value = true;
        page.value = 0;
        fetchRunningJobs();
        fetchFinishJobs();
      }).catch(() => {});
    };
    const fetchRunningJobs = () => {
      if (!isLogin.value) {
        return;
      }
      // 获取运行中的任务
      httpGet(`/api/dall/jobs?finish=false`).then(res => {
        runningJobs.value = res.data.items;
      }).catch(e => {
        ElMessage.error("获取任务失败：" + e.message);
      });
    };
    const page = ref(1);
    const pageSize = ref(15);
    // 获取已完成的任务
    const fetchFinishJobs = () => {
      if (!isLogin.value) {
        return;
      }
      loading.value = true;
      page.value = page.value + 1;
      httpGet(`/api/dall/jobs?finish=true&page=${page.value}&page_size=${pageSize.value}`).then(res => {
        if (res.data.items.length < pageSize.value) {
          isOver.value = true;
        }
        const imageList = res.data.items;
        for (let i = 0; i < imageList.length; i++) {
          imageList[i]["img_thumb"] = imageList[i]["img_url"] + "?imageView2/4/w/300/h/0/q/75";
        }
        if (page.value === 1) {
          finishedJobs.value = imageList;
        } else {
          finishedJobs.value = finishedJobs.value.concat(imageList);
        }
        loading.value = false;
      }).catch(e => {
        ElMessage.error("获取任务失败：" + e.message);
      });
    };

    // 创建绘图任务
    const promptRef = ref(null);
    const generate = () => {
      if (params.value.prompt === "") {
        promptRef.value.focus();
        return ElMessage.error("请输入绘画提示词！");
      }
      if (!isLogin.value) {
        store.setShowLoginDialog(true);
        return;
      }
      httpPost("/dall/image", params.value).then(() => {
        ElMessage.success("任务执行成功！");
        power.value -= dallPower.value;
        fetchRunningJobs();
      }).catch(e => {
        ElMessage.error("任务执行失败：" + e.message);
      });
    };
    const removeImage = item => {
      ElMessageBox.confirm("此操作将会删除任务和图片，继续操作码?", "删除提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        httpGet("/dall/remove", {
          id: item.id
        }).then(() => {
          ElMessage.success("任务删除成功");
          page.value = 0;
          isOver.value = false;
          fetchFinishJobs();
        }).catch(e => {
          ElMessage.error("任务删除失败：" + e.message);
        });
      }).catch(() => {});
    };
    const previewImg = item => {
      previewURL.value = item.img_url;
    };

    // 发布图片到作品墙
    const publishImage = (item, action) => {
      let text = "图片发布";
      if (action === false) {
        text = "取消发布";
      }
      httpGet("/dall/publish", {
        id: item.id,
        action: action
      }).then(() => {
        ElMessage.success(text + "成功");
        item.publish = action;
        page.value = 0;
        isOver.value = false;
      }).catch(e => {
        ElMessage.error(text + "失败：" + e.message);
      });
    };
    const isGenerating = ref(false);
    const generatePrompt = () => {
      if (params.value.prompt === "") {
        return showMessageError("请输入原始提示词");
      }
      isGenerating.value = true;
      httpPost("/prompt/image", {
        prompt: params.value.prompt
      }).then(res => {
        params.value.prompt = res.data;
        isGenerating.value = false;
      }).catch(e => {
        showMessageError("生成提示词失败：" + e.message);
        isGenerating.value = false;
      });
    };
    const changeModel = model => {
      if (model.value.startsWith("dall")) {
        sizes.value = dalleSizes;
      } else {
        sizes.value = fluxSizes;
      }
      params.value.model_id = selectedModel.value.id;
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_v3_waterfall = _resolveComponent("v3-waterfall");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_image_viewer = _resolveComponent("el-image-viewer");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[11] || (_cache[11] = _createElementVNode("h2", null, "DALL-E 创作中心", -1)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
        model: params.value,
        "label-width": "80px",
        "label-position": "left"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form_item, {
          label: "生图模型"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_select, {
            modelValue: selectedModel.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedModel.value = $event),
            style: {
              "width": "150px"
            },
            placeholder: "请选择模型",
            onChange: changeModel
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(models.value, v => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: v.name,
                value: v,
                key: v.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_form_item, {
          label: "图片质量"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_select, {
            modelValue: params.value.quality,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.value.quality = $event),
            style: {
              "width": "150px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(qualities, v => {
              return _createVNode(_component_el_option, {
                label: v.name,
                value: v.value,
                key: v.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_form_item, {
          label: "图片尺寸"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_select, {
            modelValue: params.value.size,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => params.value.size = $event),
            style: {
              "width": "150px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sizes.value, v => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: v,
                value: v,
                key: v
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_form_item, {
          label: "图片样式"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_select, {
            modelValue: params.value.style,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => params.value.style = $event),
            style: {
              "width": "150px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(styles, v => {
              return _createVNode(_component_el_option, {
                label: v.name,
                value: v.value,
                key: v.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "生动使模型倾向于生成超真实和戏剧性的图像",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "info-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_13, [_withDirectives(_createVNode(_component_el_input, {
          modelValue: params.value.prompt,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => params.value.prompt = $event),
          autosize: {
            minRows: 4,
            maxRows: 6
          },
          type: "textarea",
          ref_key: "promptRef",
          ref: promptRef,
          placeholder: "请在此输入绘画提示词，您也可以点击下面的提示词助手生成绘画提示词"
        }, null, 8, ["modelValue"]), [[_directive_loading, isGenerating.value]])]), _createVNode(_component_el_row, {
          class: "text-info"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "generate-btn",
            size: "small",
            onClick: generatePrompt,
            color: "#5865f2",
            disabled: isGenerating.value
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [_createElementVNode("i", {
              class: "iconfont icon-chuangzuo",
              style: {
                "margin-right": "5px"
              }
            }, null, -1), _createElementVNode("span", null, "生成专业绘画指令", -1)])),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_text, {
            type: "primary"
          }, {
            default: _withCtx(() => [_cache[8] || (_cache[8] = _createTextVNode("每次绘图消耗 ")), _createVNode(_component_el_text, {
              type: "warning"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(dallPower.value) + "算力，", 1)]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_text, {
            type: "primary"
          }, {
            default: _withCtx(() => [_cache[9] || (_cache[9] = _createTextVNode("当前可用 ")), _createVNode(_component_el_text, {
              type: "warning"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(power.value) + "算力", 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_button, {
        type: "primary",
        dark: false,
        round: "",
        onClick: generate
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode(" 立即生成 ")])),
        _: 1
      })])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
        class: "task-list-inner",
        style: _normalizeStyle({
          height: listBoxHeight.value + 'px'
        })
      }, [_createElementVNode("div", _hoisted_17, [_cache[22] || (_cache[22] = _createElementVNode("h2", {
        class: "text-xl"
      }, "任务列表", -1)), _createVNode(TaskList, {
        list: runningJobs.value
      }, null, 8, ["list"]), finishedJobs.value.length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_cache[21] || (_cache[21] = _createElementVNode("h2", {
        class: "text-xl"
      }, "创作记录", -1)), _createElementVNode("div", _hoisted_18, [finishedJobs.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_v3_waterfall, {
        id: "waterfall",
        list: finishedJobs.value,
        srcKey: "img_thumb",
        gap: 20,
        bottomGap: -10,
        colWidth: colWidth.value,
        distanceToScroll: 100,
        isLoading: loading.value,
        isOver: isOver.value,
        onScrollReachBottom: _cache[5] || (_cache[5] = $event => fetchFinishJobs())
      }, {
        default: _withCtx(slotProp => [_createElementVNode("div", _hoisted_20, [slotProp.item.img_url !== '' ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          onClick: $event => previewImg(slotProp.item),
          src: slotProp.item['img_thumb'],
          fit: "cover",
          loading: "lazy"
        }, {
          placeholder: _withCtx(() => _cache[12] || (_cache[12] = [_createElementVNode("div", {
            class: "image-slot"
          }, "正在加载图片", -1)])),
          error: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Picture))]),
            _: 1
          })])]),
          _: 2
        }, 1032, ["onClick", "src"])) : slotProp.item.progress === 101 ? (_openBlock(), _createBlock(_component_el_image, {
          key: 1
        }, {
          error: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_cache[15] || (_cache[15] = _createElementVNode("div", {
            class: "title"
          }, "任务失败", -1)), _createElementVNode("div", _hoisted_24, [_createVNode(_component_el_popover, {
            title: "错误详情",
            trigger: "click",
            width: 250,
            content: slotProp.item['err_msg'],
            placement: "top"
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_button, {
              type: "info"
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("详情")])),
              _: 1
            })]),
            _: 2
          }, 1032, ["content"]), _createVNode(_component_el_button, {
            type: "danger",
            onClick: $event => removeImage(slotProp.item)
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("删除")])),
            _: 2
          }, 1032, ["onClick"])])])])]),
          _: 2
        }, 1024)) : (_openBlock(), _createBlock(_component_el_image, {
          key: 2
        }, {
          error: _withCtx(() => _cache[16] || (_cache[16] = [_createElementVNode("div", {
            class: "image-slot"
          }, [_createElementVNode("i", {
            class: "iconfont icon-loading"
          }), _createElementVNode("span", null, "正在下载图片")], -1)])),
          _: 1
        })), _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_tooltip, {
          content: "删除",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "danger",
            icon: _unref(Delete),
            onClick: $event => removeImage(slotProp.item),
            circle: ""
          }, null, 8, ["icon", "onClick"])]),
          _: 2
        }, 1024), slotProp.item.publish ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          content: "取消分享",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "warning",
            onClick: $event => publishImage(slotProp.item, false),
            circle: ""
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [_createElementVNode("i", {
              class: "iconfont icon-cancel-share"
            }, null, -1)])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 2
        }, 1024)) : (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 1,
          content: "分享",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "success",
            onClick: $event => publishImage(slotProp.item, true),
            circle: ""
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [_createElementVNode("i", {
              class: "iconfont icon-share-bold"
            }, null, -1)])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 2
        }, 1024)), _createVNode(_component_el_tooltip, {
          content: "复制提示词",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "info",
            circle: "",
            class: "copy-prompt",
            "data-clipboard-text": slotProp.item.prompt
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [_createElementVNode("i", {
              class: "iconfont icon-file"
            }, null, -1)])),
            _: 2
          }, 1032, ["data-clipboard-text"])]),
          _: 2
        }, 1024)])])]),
        footer: _withCtx(() => _cache[20] || (_cache[20] = [_createElementVNode("div", {
          class: "no-more-data"
        }, [_createElementVNode("span", null, "没有更多数据了"), _createElementVNode("i", {
          class: "iconfont icon-face"
        })], -1)])),
        _: 1
      }, 8, ["list", "colWidth", "isLoading", "isOver"])])) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        "image-size": 100,
        image: _unref(nodata),
        description: "暂无记录"
      }, null, 8, ["image"]))])], 64)) : _createCommentVNode("", true)])], 4), _createVNode(BackTop, {
        right: 30,
        bottom: 30
      })])])]), previewURL.value !== '' ? (_openBlock(), _createBlock(_component_el_image_viewer, {
        key: 0,
        onClose: _cache[6] || (_cache[6] = () => {
          previewURL.value = '';
        }),
        "url-list": [previewURL.value]
      }, null, 8, ["url-list"])) : _createCommentVNode("", true)]);
    };
  }
};